import { render, staticRenderFns } from "./ImageIcon.vue?vue&type=template&id=5ed495ff&scoped=true&"
import script from "./ImageIcon.vue?vue&type=script&lang=js&"
export * from "./ImageIcon.vue?vue&type=script&lang=js&"
import style0 from "./ImageIcon.vue?vue&type=style&index=0&id=5ed495ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed495ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VImg,VProgressCircular,VTooltip})
